import React, { useEffect } from "react";
import {
  Typography,
  IconButton,
  Box,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  CircularProgress,
  Snackbar,
  Alert,
  InputAdornment,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { purchaseDataBundle } from "./api";
import Preloader from "./components/Preloader";
import { getOrganizationSettings } from "./utils/storage";
import { useAirtimePurchase, useCableSubscriptions, useDataBundle, usePurchaseData, usePurchaseElectricity, useSubscribeCableTV, useVerifyMeter, useVerifySmartCard } from "./api/hooks/useWalletTransactions";
import { useNavigate } from "react-router-dom";
import { useMeterServices } from "./api/hooks/usePayment";
import CustomButton from "./components/customButton";
import { useAppDispatch, useAppSelector } from "./redux/hook";
import { cableSubscriptions } from "./redux/cableSubscriptions/api";

export default function Bills({ setSidebarOpen }) {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch { }

  const [airtimeDialogOpen, setAirtimeDialogOpen] = React.useState(false);
  const [airtimeProvider, setAirtimeProvider] = React.useState("mtn");
  const [airtimeAmount, setAirtimeAmount] = React.useState("");
  const [airtimePhone, setAirtimePhone] = React.useState("");
  const [airtimePin, setAirtimePin] = React.useState("");
  const [airtimeLoading, setAirtimeLoading] = React.useState(false);
  const [airtimeError, setAirtimeError] = React.useState("");
  const [airtimeSuccess, setAirtimeSuccess] = React.useState("");
  const [airtimeSnackbarOpen, setAirtimeSnackbarOpen] = React.useState(false);
  const [dataBundle, setDataBundle] = React.useState(undefined);
  const [dataProvider, setDataProvider] = React.useState();


  const navigate = useNavigate();

  const { data: meterServicesData, isLoading: isMeterServiceLoading, error: meterServiceError, refetch: refetchMeterServices } = useMeterServices();

  const { data: dataBundlesData, isLoading: dataBundleLoading, error: dataBundleError, refetch: dataBundleFetch } = useDataBundle(dataProvider);

  const buyAirtimeMutation = useAirtimePurchase();
  const verifyMeterMutation = useVerifyMeter();
  const verifySmartCardMutation = useVerifySmartCard();
  const subscribeCableTVMutation = useSubscribeCableTV();
  const purchaseElectricityMutation = usePurchaseElectricity();
  const purchaseDataMutation = usePurchaseData();

  const {
    organization_subscribed_features,
    customized_app_displayable_menu_items,
  } = getOrganizationSettings();

  const handleAirtimePurchase = async () => {
    setAirtimeLoading(true);
    setAirtimeError("");
    setAirtimeSuccess("");
    try {
      const payload = {
        network_provider: airtimeProvider,
        final_amount: airtimeAmount,
        phone_number: airtimePhone,
        transaction_pin: airtimePin,
      };

      console.log(payload, "Airtime purchase response");

      buyAirtimeMutation.mutate(payload);


      //   if (res.status) {
      //     setAirtimeSuccess(res.message || "Airtime purchased successfully!");
      //     setAirtimeSnackbarOpen(true);
      //     setAirtimeDialogOpen(false);
      //     setAirtimeAmount("");
      //     setAirtimePhone("");
      //     setAirtimePin("");
      //   } else {
      //     setAirtimeError(res.message || "Failed to purchase airtime.");
      //   }
    } catch (e) {
      setAirtimeError(
        e?.response?.data?.message || "Failed to purchase airtime."
      );
    }
    // setAirtimeLoading(false);
  };

  useEffect(() => {

    if (meterServicesData == undefined) return;

    console.log(meterServicesData.data, "Log things");


    if (meterServicesData.status) {
      setElectricityDiscos(meterServicesData.data.data.electricity_discos || []);
      setMeterTypes(meterServicesData.data.data.meter_types || []);
      setElectricityDisco(
        meterServicesData.data.data.electricity_discos?.[0]?.id || "abuja-electric"
      );
    }

  }, [meterServicesData])

  useEffect(() => {

    if (!buyAirtimeMutation.data) return;

    if (buyAirtimeMutation.data.status) {
      // setTransferResult(buyAirtimeMutation.data);
      console.log(buyAirtimeMutation.data, "This is the main thing");
      console.log(buyAirtimeMutation.data.data.message, "This is the main thing");

      navigate("/success-page", { state: { title: "Transaction Successful", message: buyAirtimeMutation.data.data.message } })

    } else {
      // setTransferError(
      //   buyAirtimeMutation.data.message || "Transfer processing failed"
      // );
    }

  }, [buyAirtimeMutation.data])

  useEffect(() => {

    if (!purchaseElectricityMutation.data) return;

    if (purchaseElectricityMutation.data.data.status === true) {
      // setTransferResult(purchaseElectricityMutation.data);
      console.log(purchaseElectricityMutation.data, "This is the electricity thing");
      console.log(purchaseElectricityMutation.data.data.message, "This is the main thing");

      navigate("/success-page", { state: { title: "Transaction Successful", message: purchaseElectricityMutation.data.data.message } })

    } else {
      setElectricityError(
        purchaseElectricityMutation.data.data.message || "Transfer processing failed"
      );
    }

  }, [purchaseElectricityMutation.data])

  useEffect(() => {

    if (!subscribeCableTVMutation.data) return;

    if (subscribeCableTVMutation.data.status) {
      // setTransferResult(subscribeCableTVMutation.data);
      console.log(subscribeCableTVMutation.data, "This is the main thing");
      console.log(subscribeCableTVMutation.data.data.message, "This is the main thing");

      navigate("/success-page", { state: { title: "Transaction Successful", message: subscribeCableTVMutation.data.data.message } })

    } else {
      // setTransferError(
      //   subscribeCableTVMutation.data.message || "Transfer processing failed"
      // );
    }

  }, [subscribeCableTVMutation.data])

  useEffect(() => {

    if (!purchaseDataMutation.data) return;

    if (purchaseDataMutation.data.status) {
      // setTransferResult(purchaseDataMutation.data);
      console.log(purchaseDataMutation.data, "This is the main thing");
      console.log(purchaseDataMutation.data.data.message, "This is the main thing");

      navigate("/success-page", { state: { title: "Transaction Successful", message: purchaseDataMutation.data.data.message } })

    } else {
      // setTransferError(
      //   purchaseDataMutation.data.message || "Transfer processing failed"
      // );
    }

  }, [purchaseDataMutation.data])

  useEffect(() => {

    if (!subscribeCableTVMutation.error) return;

    if (subscribeCableTVMutation.error.response.data.status) {
      // setTransferResult(subscribeCableTVMutation.data);
      console.log(subscribeCableTVMutation.error.data.response, "This is the main thing");
      console.log(subscribeCableTVMutation.error.data.response.data.message, "This is the main thing");

      setCableError(subscribeCableTVMutation.error.response.data.message || "Subscription failed.");

    } else {
      // setTransferError(
      //   subscribeCableTVMutation.data.message || "Transfer processing failed"
      // );
    }

  }, [subscribeCableTVMutation.error])

  useEffect(() => {

    if (!purchaseDataMutation.error) return;

    if (purchaseDataMutation.error.response.data.status) {
      // setTransferResult(purchaseDataMutation.data);
      console.log(purchaseDataMutation.error.data.response, "This is the main thing");
      console.log(purchaseDataMutation.error.data.response.data.message, "This is the main thing");

      setDataError(purchaseDataMutation.error.response.data.message || "Subscription failed.");

    } else {
      // setTransferError(
      //   purchaseDataMutation.data.message || "Transfer processing failed"
      // );
    }

  }, [purchaseDataMutation.error])

  useEffect(() => {

    if (!purchaseElectricityMutation.error) return;

    console.log(purchaseElectricityMutation.error, "PUrchase electricity error");

    if (!purchaseElectricityMutation.error.response.data.status) {
      // setTransferResult(purchaseElectricityMutation.data);
      console.log(purchaseElectricityMutation.error, "This is the main thing");
      console.log(purchaseElectricityMutation.error.response.data.message, "This is the main thing");

      setElectricityError(purchaseElectricityMutation.error.response.data.message || "Subscription failed.");


      // navigate("/success-page", { state: { title: "Transaction Successful", message: purchaseElectricityMutation.data.data.message } })

    } else {
      // setTransferError(
      //   purchaseElectricityMutation.data.message || "Transfer processing failed"
      // );
    }

  }, [purchaseElectricityMutation.error])

  // Internet/Data state
  const [dataDialogOpen, setDataDialogOpen] = React.useState(false);
  const [dataBundles, setDataBundles] = React.useState([]);
  const [dataPhone, setDataPhone] = React.useState("");
  const [dataPin, setDataPin] = React.useState("");
  const [dataLoading, setDataLoading] = React.useState(false);
  const [dataError, setDataError] = React.useState("");
  const [dataSuccess, setDataSuccess] = React.useState("");
  const [dataSnackbarOpen, setDataSnackbarOpen] = React.useState(false);
  const [bundlesLoading, setBundlesLoading] = React.useState(false);
  const [bundlesError, setBundlesError] = React.useState("");

  const handleOpenDataDialog = async () => {
    setDataDialogOpen(true);
    setBundlesLoading(true);
    setBundlesError("");

    setBundlesLoading(false);
  };

  const handleDataPurchase = async () => {
    setDataLoading(true);
    setDataError("");
    setDataSuccess("");
    try {

      const payload = {
        network_provider: dataProvider,
        data_plan: dataBundle,
        phone_number: dataPhone,
        transaction_pin: dataPin,
      }

      purchaseDataMutation.mutate(payload);
    } catch (e) {
      setDataError(e?.response?.data?.message || "Failed to purchase data.");
    }
    setDataLoading(false);
  };

  // Cable TV state
  const [cableDialogOpen, setCableDialogOpen] = React.useState(false);
  const [cableProvider, setCableProvider] = React.useState("gotv");
  const [cableSmartCard, setCableSmartCard] = React.useState("");
  const [cableVerified, setCableVerified] = React.useState(false);
  const [cableVerifyError, setCableVerifyError] = React.useState("");
  const [cableCustomer, setCableCustomer] = React.useState(null);
  const [cablePlans, setCablePlans] = React.useState([]);
  const [cablePlan, setCablePlan] = React.useState("");
  const [cablePhone, setCablePhone] = React.useState("");
  const [cablePin, setCablePin] = React.useState("");
  const [cableError, setCableError] = React.useState("");
  const [cableSuccess, setCableSuccess] = React.useState("");
  const [cableSnackbarOpen, setCableSnackbarOpen] = React.useState(false);

  const dispatch = useAppDispatch();

  const cableSubscriptionResponse = useAppSelector((state) => state.cableSubscriptionSlice.response);
  const cableSubscriptionLoading = useAppSelector((state) => state.cableSubscriptionSlice.loading);

  // Electricity state
  const [electricityDialogOpen, setElectricityDialogOpen] =
    React.useState(false);
  const [electricityDisco, setElectricityDisco] =
    React.useState("abuja-electric");
  const [meterType, setMeterType] = React.useState("prepaid");
  const [meterNumber, setMeterNumber] = React.useState("");
  const [electricityAmount, setElectricityAmount] = React.useState("");
  const [electricityPin, setElectricityPin] = React.useState("");
  const [electricityLoading, setElectricityLoading] = React.useState(false);
  const [electricityError, setElectricityError] = React.useState("");
  const [electricitySuccess, setElectricitySuccess] = React.useState("");
  React.useState(false);
  const [electricityDiscos, setElectricityDiscos] = React.useState([]);
  const [meterTypes, setMeterTypes] = React.useState([]);
  const [meterVerified, setMeterVerified] = React.useState(false);
  const [meterVerifyError, setMeterVerifyError] = React.useState("");
  const [meterCustomer, setMeterCustomer] = React.useState(null);
  const [servicesLoading, setServicesLoading] = React.useState(false);
  const [servicesError, setServicesError] = React.useState("");

  // Pin visibility states
  const [showAirtimePin, setShowAirtimePin] = React.useState(false);
  const [showDataPin, setShowDataPin] = React.useState(false);
  const [showCablePin, setShowCablePin] = React.useState(false);
  const [showElectricityPin, setShowElectricityPin] = React.useState(false);

  const handleOpenCableDialog = () => {
    setCableDialogOpen(true);
    setCableProvider("gotv");
    setCableSmartCard("");
    setCableVerified(false);
    setCableVerifyError("");
    setCableCustomer(null);
    setCablePlans([]);
    setCablePlan("");
    setCablePhone("");
    setCablePin("");
    setCableError("");
    setCableSuccess("");
  };

  useEffect(() => {
    console.log(organization_subscribed_features, "Org Settings");
  }, [organization_subscribed_features]);

  const handleVerifySmartCard = async () => {
    setCableVerifyError("");
    setCableCustomer(null);

    console.log("Verifying the smart card");
    console.log(cableProvider);
    console.log(cableSmartCard);

    const payload = {
      cable_tv_type: cableProvider,
      smart_card_number: cableSmartCard,
    };

    verifySmartCardMutation.mutate(payload);

  };

  useEffect(() => {

    if (verifySmartCardMutation.data == undefined) return;

    console.log(verifySmartCardMutation.data, "Verify Smart card things");


    if (verifySmartCardMutation.data.data.status === true) {
      setCableCustomer(verifySmartCardMutation.data.data.data);
      setCableVerified(true);

      // @ts-ignore
      dispatch(cableSubscriptions(cableProvider));

    } else {
      setCableVerifyError(verifySmartCardMutation.data.message || "Verification failed.");
      setCableVerified(false);
    }

  }, [verifySmartCardMutation.data])

  useEffect(() => {

    if (cableSubscriptionResponse == undefined) return;

    if (cableSubscriptionResponse.status === true) {
      // Fetch plans
      if (cableSubscriptionResponse.status && Array.isArray(cableSubscriptionResponse.data)) {
        setCablePlans(cableSubscriptionResponse.data);
        setCablePlan(cableSubscriptionResponse.data[0]?.variation_code || "");
      } else {
        setCablePlans([]);
      }
    }

  }, [cableSubscriptionResponse])

  const handleCableSubscribe = async () => {
    setCableError("");
    setCableSuccess("");

    const payload = {
      cable_tv_type: cableProvider,
      smart_card_number: cableSmartCard,
      subscription_plan: cablePlan,
      phone_number: cablePhone,
      transaction_pin: cablePin,
    }

    subscribeCableTVMutation.mutate(payload)
  };


  useEffect(() => {

    if (dataProvider && dataProvider != "") {
      dataBundleFetch();
    }

  }, [dataProvider])

  useEffect(() => {

    if (!dataBundlesData) return;

    if (dataBundlesData) {
      // try {
      if (dataBundlesData.data.status && Array.isArray(dataBundlesData.data.data)) {
        setDataBundles(dataBundlesData.data.data);
        setDataBundle(dataBundlesData.data.data[0]?.variation_code || "");
      } else {
        setBundlesError(dataBundlesData.data.message || "Failed to fetch bundles.");
        setDataBundles([]);
      }
      // } catch (e) {
      //   setBundlesError(e?.response?.data?.message || "Failed to fetch bundles.");
      //   setDataBundles([]);
      // }
    }

  }, [dataBundlesData])

  // Electricity handlers
  const handleOpenElectricityDialog = async () => {
    // setServicesLoading(true);
    // setServicesError("");
    try {

      if (electricityDiscos.length == 0) {
        refetchMeterServices()
      } else {
        setElectricityDialogOpen(true);
      }

      // const res = await getMeterServices();
      // if (res.status && res.data) {
      //   setElectricityDiscos(res.data.electricity_discos || []);
      //   setMeterTypes(res.data.meter_types || []);
      //   setElectricityDisco(
      //     res.data.electricity_discos?.[0]?.id || "abuja-electric"
      //   );
      //   setMeterType(res.data.meter_types?.[0]?.id || "prepaid");
      // } else {
      //   setServicesError(res.message || "Failed to fetch meter services.");
      //   setElectricityDiscos([]);
      //   setMeterTypes([]);
      // }
    } catch (e) {
      setServicesError(
        e?.response?.data?.message || "Failed to fetch meter services."
      );
      setElectricityDiscos([]);
      setMeterTypes([]);
    }
    setServicesLoading(false);
  };

  useEffect(() => {

    if (subscribeCableTVMutation.data == undefined) return;

    if (subscribeCableTVMutation.data.data.status === true) {

      navigate("/success-page", { state: { title: "Transaction Successful", message: subscribeCableTVMutation.data.data.message } })
    } else {
      const errorMessage = subscribeCableTVMutation.data.data.message || "Meter verification failed.";
      setMeterVerifyError(
        `${errorMessage} Please check your meter number and try again.`
      );
      setMeterVerified(false);
    }

  }, [subscribeCableTVMutation.data])

  useEffect(() => {

    if (verifyMeterMutation.data == undefined) return;

    if (verifyMeterMutation.data.data.status === true) {
      setMeterCustomer(verifyMeterMutation.data.data.data);
      setMeterVerified(true);
    } else {
      const errorMessage = verifyMeterMutation.data.data.message || "Meter verification failed.";
      setMeterVerifyError(
        `${errorMessage} Please check your meter number and try again.`
      );
      setMeterVerified(false);
    }

  }, [verifyMeterMutation.data])

  useEffect(() => {

    if (verifyMeterMutation.error == undefined) return;

    if (!verifyMeterMutation.data.status) {
      const errorMessage = verifyMeterMutation.data.message || "Meter verification failed.";
      setMeterVerifyError(
        `${errorMessage} Please check your meter number and try again.`
      );
      setMeterVerified(false);
    }


  }, [verifyMeterMutation.error])

  const handleVerifyMeter = async () => {
    setMeterVerifyError("");
    setMeterCustomer(null);
    try {

      const payload = {
        electricity_disco: electricityDisco,
        meter_type: meterType,
        meter_number: meterNumber,
      };

      verifyMeterMutation.mutate(payload)

    } catch (e) {
      const errorMessage =
        e?.response?.data?.message || "Meter verification failed.";
      setMeterVerifyError(
        `${errorMessage} Please check your meter number and try again.`
      );
      setMeterVerified(false);
    }
  };


  const handleElectricityPurchase = async () => {
    setElectricityLoading(true);
    setElectricityError("");
    try {

      const payload = {
        meter_number: meterNumber,
        electricity_disco: electricityDisco,
        meter_type: meterType,
        final_amount: electricityAmount,
        transaction_pin: electricityPin,
      };

      purchaseElectricityMutation.mutate(payload)

    } catch (e) {
      setElectricityError(
        e?.response?.data?.message || "Electricity purchase failed."
      );
    }
    setElectricityLoading(false);
  };

  const loading =
    airtimeLoading ||
    dataLoading ||
    bundlesLoading ||
    electricityLoading ||
    servicesLoading;

  if (loading || isMeterServiceLoading)
    return <Preloader fullScreen={true} message="Processing your request..." />;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 sm:gap-4">
            <button
              onClick={() => setSidebarOpen && setSidebarOpen(true)}
              className="block xl:hidden text-gray-600 hover:text-gray-900 p-1"
            >
              <MenuIcon />
            </button>
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-2xl font-bold text-gray-900 truncate">
                Bills Payments
              </h1>
              <p className="text-sm text-gray-600 truncate">
                Pay your bills and utilities
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 sm:px-6 py-6 sm:py-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
          Bills Payments
        </h1>

        {organization_subscribed_features["vtu-mgt"] && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            {/* Airtime */}
            {customized_app_displayable_menu_items["display-airtime-menu"] && (
              <div>
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 flex flex-col items-center min-h-[200px]">
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-full flex items-center justify-center text-2xl mb-4">
                    📱
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Airtime
                  </h3>
                  <p className="text-gray-600 text-center mb-6">
                    Buy airtime for any network.
                  </p>
                  <button
                    onClick={() => setAirtimeDialogOpen(true)}
                    className="mt-auto bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-200 shadow-sm"
                  >
                    Buy Airtime
                  </button>
                </div>
                {/* Airtime Purchase Dialog */}
                <Dialog
                  open={airtimeDialogOpen}
                  onClose={() => setAirtimeDialogOpen(false)}
                  maxWidth="xs"
                  fullWidth
                >
                  <DialogTitle>Buy Airtime</DialogTitle>
                  <DialogContent>
                    <TextField
                      select
                      label="Network Provider"
                      value={airtimeProvider}
                      onChange={(e) => setAirtimeProvider(e.target.value)}
                      fullWidth
                      sx={{ mb: 2 }}
                    >
                      <MenuItem value="">-- Select Provider --</MenuItem>
                      <MenuItem value="mtn">MTN</MenuItem>
                      <MenuItem value="airtel">Airtel</MenuItem>
                      <MenuItem value="glo">Glo</MenuItem>
                      <MenuItem value="9mobile">9mobile</MenuItem>
                    </TextField>
                    <TextField
                      label="Amount"
                      type="number"
                      fullWidth
                      value={airtimeAmount}
                      onChange={(e) => setAirtimeAmount(e.target.value)}
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="Phone Number"
                      type="tel"
                      fullWidth
                      value={airtimePhone}
                      onChange={(e) => setAirtimePhone(e.target.value)}
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="Transaction Pin"
                      type={showAirtimePin ? "text" : "password"}
                      fullWidth
                      value={airtimePin}
                      onChange={(e) => setAirtimePin(e.target.value)}
                      sx={{ mb: 2 }}
                      inputProps={{ maxLength: 6 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowAirtimePin(!showAirtimePin)}
                              edge="end"
                            >
                              {showAirtimePin ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {airtimeError && (
                      <Typography color="error" sx={{ mb: 1 }}>
                        {airtimeError}
                      </Typography>
                    )}
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setAirtimeDialogOpen(false)}
                      disabled={airtimeLoading}
                    >
                      Cancel
                    </Button>

                    <Button
                      onClick={handleAirtimePurchase}
                      variant="contained"
                      color="primary"
                      disabled={
                        airtimeLoading ||
                        !airtimeAmount ||
                        !airtimePhone ||
                        !airtimePin
                      }
                    >
                      {airtimeLoading ? <CircularProgress size={20} /> : "Buy"}
                    </Button>
                  </DialogActions>
                </Dialog>
                <Snackbar
                  open={airtimeSnackbarOpen}
                  autoHideDuration={3000}
                  onClose={() => setAirtimeSnackbarOpen(false)}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert
                    onClose={() => setAirtimeSnackbarOpen(false)}
                    severity="success"
                    sx={{ width: "100%" }}
                    elevation={6}
                    variant="filled"
                  >
                    {airtimeSuccess}
                  </Alert>
                </Snackbar>
              </div>
            )}

            {customized_app_displayable_menu_items["display-data-menu"] && (
              <div>
                {/* Internet */}
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 flex flex-col items-center min-h-[200px]">
                  <div className="w-14 h-14 bg-gradient-to-br from-green-600 to-emerald-600 rounded-full flex items-center justify-center text-2xl mb-4">
                    🌐
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Internet
                  </h3>
                  <p className="text-gray-600 text-center mb-6">
                    Pay for internet data bundles.
                  </p>
                  <button
                    onClick={handleOpenDataDialog}
                    className="mt-auto bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition duration-200 shadow-sm"
                  >
                    Buy Data
                  </button>
                </div>
                {/* Data Purchase Dialog */}
                <Dialog
                  open={dataDialogOpen}
                  onClose={() => setDataDialogOpen(false)}
                  maxWidth="xs"
                  fullWidth
                >
                  <DialogTitle>Buy Data</DialogTitle>
                  <DialogContent>
                    <TextField
                      select
                      label="Network Provider"
                      value={dataProvider}
                      onChange={async (e) => {
                        setDataProvider(e.target.value);
                        setBundlesLoading(true);
                        setBundlesError("");
                        try {
                          // const res = await getDataBundles(e.target.value);
                          // if (res.status && Array.isArray(res.data)) {
                          //   setDataBundles(res.data);
                          //   setDataBundle(res.data[0]?.variation_code || "");
                          // } else {
                          //   setBundlesError(
                          //     res.message || "Failed to fetch bundles."
                          //   );
                          //   setDataBundles([]);
                          // }
                        } catch (err) {
                          setBundlesError(
                            err?.response?.data?.message ||
                            "Failed to fetch bundles."
                          );
                          setDataBundles([]);
                        }
                        setBundlesLoading(false);
                      }}
                      fullWidth
                      sx={{ mb: 2 }}
                    >
                      <MenuItem value="">-- Select Provider --</MenuItem>
                      <MenuItem value="mtn-data">MTN</MenuItem>
                      <MenuItem value="glo-data">Glo</MenuItem>
                      <MenuItem value="airtel-data">Airtel</MenuItem>
                      <MenuItem value="9mobile-data">9mobile</MenuItem>
                    </TextField>
                    {<div>
                      {dataBundleLoading ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 120,
                          }}
                        >
                          <CircularProgress />
                        </Box>
                      ) : dataBundleError ? (
                        <Typography color="error" sx={{ mb: 2 }}>
                          {dataBundleError.response.data.error}
                        </Typography>
                      ) : (
                        <>
                          <TextField
                            select
                            label="Data Plan"
                            value={dataBundle}
                            onChange={(e) => setDataBundle(e.target.value)}
                            fullWidth
                            sx={{ mb: 2 }}
                          >
                            {dataBundles.map((bundle) => (
                              <MenuItem
                                key={bundle.variation_code}
                                value={bundle.variation_code}
                              >
                                {bundle.name} ({bundle.variation_amount})
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            label="Phone Number"
                            type="tel"
                            fullWidth
                            value={dataPhone}
                            onChange={(e) => setDataPhone(e.target.value)}
                            sx={{ mb: 2 }}
                          />
                          <TextField
                            label="Transaction Pin"
                            type={showDataPin ? "text" : "password"}
                            fullWidth
                            value={dataPin}
                            onChange={(e) => setDataPin(e.target.value)}
                            sx={{ mb: 2 }}
                            inputProps={{ maxLength: 6 }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => setShowDataPin(!showDataPin)}
                                    edge="end"
                                  >
                                    {showDataPin ? (
                                      <VisibilityOffIcon />
                                    ) : (
                                      <VisibilityIcon />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          {purchaseDataMutation.error && (
                            <Typography color="error" sx={{ mb: 1 }}>
                              {purchaseDataMutation.error.response.data.message}
                            </Typography>
                          )}
                        </>
                      )}
                    </div>}
                  </DialogContent>
                  <DialogActions>

                    <CustomButton label={"Cancel"}
                      fullWidth={false}
                      outline onPress={() => setDataDialogOpen(false)} />

                    <CustomButton
                      label={"Buy Data"}
                      onPress={handleDataPurchase}
                      fullWidth={false}
                      isLoading={purchaseDataMutation.isPending}
                      isEnabled={!purchaseDataMutation.isPending && dataProvider && dataBundle && dataPhone && dataPin}
                    />

                  </DialogActions>
                </Dialog>
                <Snackbar
                  open={dataSnackbarOpen}
                  autoHideDuration={3000}
                  onClose={() => setDataSnackbarOpen(false)}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert
                    onClose={() => setDataSnackbarOpen(false)}
                    severity="success"
                    sx={{ width: "100%" }}
                    elevation={6}
                    variant="filled"
                  >
                    {dataSuccess}
                  </Alert>
                </Snackbar>
              </div>
            )}

            {customized_app_displayable_menu_items[
              "display-electricity-menu"
            ] && (
                <div>
                  {/* Electricity */}
                  <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 flex flex-col items-center min-h-[200px]">
                    <div className="w-14 h-14 bg-gradient-to-br from-yellow-600 to-orange-600 rounded-full flex items-center justify-center text-2xl mb-4">
                      💡
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Electricity
                    </h3>
                    <p className="text-gray-600 text-center mb-6">
                      Pay your electricity bills easily.
                    </p>
                    <button
                      onClick={handleOpenElectricityDialog}
                      className="mt-auto bg-yellow-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-yellow-700 transition duration-200 shadow-sm"
                    >
                      Buy Electricity
                    </button>
                  </div>

                  {/* Electricity Purchase Dialog */}
                  <Dialog
                    open={electricityDialogOpen}
                    onClose={() => setElectricityDialogOpen(false)}
                    maxWidth="xs"
                    fullWidth
                  >
                    <DialogTitle>Buy Electricity</DialogTitle>
                    <DialogContent>
                      {isMeterServiceLoading ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 120,
                          }}
                        >
                          <CircularProgress />
                        </Box>
                      ) : servicesError ? (
                        <Typography color="error" sx={{ mb: 2 }}>
                          {servicesError}
                        </Typography>
                      ) : (
                        <>
                          <TextField
                            select
                            label="Electricity Disco"
                            value={electricityDisco}
                            onChange={(e) => {
                              setElectricityDisco(e.target.value);
                              setMeterVerified(false);
                              setMeterCustomer(null);
                            }}
                            fullWidth
                            sx={{ mb: 2 }}
                          >
                            {electricityDiscos.map((disco) => (
                              <MenuItem key={disco.id} value={disco.id}>
                                {disco.name}
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            select
                            label="Meter Type"
                            value={meterType}
                            onChange={(e) => {
                              setMeterType(e.target.value);
                              setMeterVerified(false);
                              setMeterCustomer(null);
                            }}
                            fullWidth
                            sx={{ mb: 2 }}
                          >
                            {meterTypes.map((type) => (
                              <MenuItem key={type.id} value={type.id}>
                                {type.name}
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            label="Meter Number"
                            value={meterNumber}
                            onChange={(e) => setMeterNumber(e.target.value)}
                            fullWidth
                            sx={{ mb: 2 }}
                            helperText="Enter your 11-digit meter number (e.g., 11111111111)"
                            inputProps={{
                              maxLength: 11,
                              pattern: "[0-9]{11}",
                            }}
                            error={
                              meterNumber.length > 0 && meterNumber.length !== 11
                            }
                          />
                          {!meterVerified && (
                            <CustomButton
                              onPress={handleVerifyMeter}
                              isEnabled={!verifyMeterMutation.isPending || !meterNumber}
                              isLoading={verifyMeterMutation.isPending}
                              label={"Verify Meter"}
                            />
                          )}
                          {meterVerifyError && (
                            <Box sx={{ mb: 2 }}>
                              <Typography color="error" sx={{ mb: 1 }}>
                                {meterVerifyError}
                              </Typography>
                              <Box
                                sx={{
                                  p: 2,
                                  borderRadius: 2,
                                  background: "#fff3cd",
                                  border: "1px solid #ffeaa7",
                                  fontSize: 14,
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontWeight: 600,
                                    mb: 1,
                                    color: "#856404",
                                  }}
                                >
                                  💡 Troubleshooting Tips:
                                </Typography>
                                <ul
                                  style={{
                                    margin: 0,
                                    paddingLeft: 20,
                                    color: "#856404",
                                  }}
                                >
                                  <li>
                                    Ensure your meter number is exactly 11 digits
                                  </li>
                                  <li>
                                    Check that you've selected the correct
                                    electricity disco
                                  </li>
                                  <li>
                                    Verify you've selected the right meter type
                                    (prepaid/postpaid)
                                  </li>
                                  <li>
                                    Make sure your meter is active and not
                                    disconnected
                                  </li>
                                  <li>
                                    Try removing any spaces or special characters
                                    from the meter number
                                  </li>
                                </ul>
                              </Box>
                            </Box>
                          )}
                          {/* Show customer info if verified */}
                          {meterVerified && meterCustomer && (
                            <Box
                              sx={{
                                mb: 2,
                                p: 2,
                                borderRadius: 2,
                                background: "#f5f7fa",
                                fontSize: 15,
                              }}
                            >
                              <div>
                                Meter Name: <b>{meterCustomer.meter_name}</b>
                              </div>
                              <div>
                                Address: <b>{meterCustomer.address}</b>
                              </div>
                              <div>
                                Meter Type: <b>{meterCustomer.meter_type}</b>
                              </div>
                              <div>
                                Meter Number: <b>{meterCustomer.meter_number}</b>
                              </div>
                            </Box>
                          )}
                          {meterVerified && (
                            <>
                              <TextField
                                label="Amount"
                                type="number"
                                fullWidth
                                value={electricityAmount}
                                onChange={(e) =>
                                  setElectricityAmount(e.target.value)
                                }
                                sx={{ mb: 2 }}
                              />
                              <TextField
                                label="Transaction Pin"
                                type={showElectricityPin ? "text" : "password"}
                                fullWidth
                                value={electricityPin}
                                onChange={(e) =>
                                  setElectricityPin(e.target.value)
                                }
                                sx={{ mb: 2 }}
                                inputProps={{ maxLength: 6 }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() =>
                                          setShowElectricityPin(
                                            !showElectricityPin
                                          )
                                        }
                                        edge="end"
                                      >
                                        {showElectricityPin ? (
                                          <VisibilityOffIcon />
                                        ) : (
                                          <VisibilityIcon />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              {electricityError && (
                                <Typography color="error" sx={{ mb: 1 }}>
                                  {electricityError}
                                </Typography>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <CustomButton
                        onPress={() => setElectricityDialogOpen(false)}
                        outline
                        fullWidth={false}
                        isEnabled={!purchaseElectricityMutation.isPending}
                        label={"Cancel"}
                      />


                      <CustomButton
                        label={"Buy Electricity"}
                        fullWidth={false}
                        isLoading={purchaseElectricityMutation.isPending}
                        isEnabled={!purchaseElectricityMutation.isPending}
                        onPress={handleElectricityPurchase} />

                    </DialogActions>
                  </Dialog>
                </div>
              )}
            {customized_app_displayable_menu_items["display-cable-tv-menu"] && (
              <div>
                {/* Cable */}
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 flex flex-col items-center min-h-[200px]">
                  <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-2xl mb-4">
                    📺
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Cable
                  </h3>
                  <p className="text-gray-600 text-center mb-6">
                    Pay for cable TV subscriptions.
                  </p>
                  <button
                    onClick={handleOpenCableDialog}
                    className="mt-auto bg-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-700 transition duration-200 shadow-sm"
                  >
                    Pay Cable TV
                  </button>
                </div>
              </div>
            )}

            {customized_app_displayable_menu_items["display-cable-tv-menu"] && (
              <div>
                {/* Cable TV Dialog */}
                <Dialog
                  open={cableDialogOpen}
                  onClose={() => setCableDialogOpen(false)}
                  maxWidth="xs"
                  fullWidth
                >
                  <DialogTitle>Pay Cable TV</DialogTitle>
                  <DialogContent>
                    {/* Step 1: Select provider and enter smart card */}
                    <TextField
                      select
                      label="Cable Provider"
                      value={cableProvider}
                      onChange={(e) => {
                        setCableProvider(e.target.value);
                        setCableVerified(false);
                        setCablePlans([]);
                        setCablePlan("");
                        setCableCustomer(null);
                      }}
                      fullWidth
                      sx={{ mb: 2 }}
                    >
                      <MenuItem value="gotv">GOtv</MenuItem>
                      <MenuItem value="dstv">DStv</MenuItem>
                      <MenuItem value="startimes">Startimes</MenuItem>
                      <MenuItem value="showmax">Showmax</MenuItem>
                    </TextField>
                    <TextField
                      label="Smart Card Number"
                      value={cableSmartCard}
                      onChange={(e) => setCableSmartCard(e.target.value)}
                      fullWidth
                      sx={{ mb: 2 }}
                    />
                    {!cableVerified && (
                      <CustomButton
                        onPress={handleVerifySmartCard}
                        isLoading={verifySmartCardMutation.isPending}
                        isEnabled={!verifySmartCardMutation.isPending}
                        label={"Verify"}
                      />
                    )}
                    {cableVerifyError && (
                      <Typography color="error" sx={{ mb: 2 }}>
                        {cableVerifyError}
                      </Typography>
                    )}
                    {/* Step 2: Show customer info and plans if verified */}
                    {cableVerified && cableCustomer && (
                      <Box
                        sx={{
                          mb: 2,
                          p: 2,
                          borderRadius: 2,
                          background: "#f5f7fa",
                          fontSize: 15,
                        }}
                      >
                        <div>
                          Customer: <b>{cableCustomer.customer_name}</b>
                        </div>
                        <div>
                          Status: <b>{cableCustomer.status}</b>
                        </div>
                        <div>
                          Due Date: <b>{cableCustomer.due_date}</b>
                        </div>
                        <div>
                          Customer No: <b>{cableCustomer.customer_number}</b>
                        </div>
                      </Box>
                    )}
                    {cableVerified && (
                      <>
                        <TextField
                          select
                          label="Subscription Plan"
                          value={cablePlan}
                          onChange={(e) => setCablePlan(e.target.value)}
                          fullWidth
                          sx={{ mb: 2 }}
                        >
                          {cablePlans.map((plan) => (
                            <MenuItem
                              key={plan.variation_code}
                              value={plan.variation_code}
                            >
                              {plan.name} ({plan.variation_amount})
                            </MenuItem>
                          ))}
                        </TextField>
                        <TextField
                          label="Phone Number"
                          type="tel"
                          fullWidth
                          value={cablePhone}
                          onChange={(e) => setCablePhone(e.target.value)}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          label="Transaction Pin"
                          type={showCablePin ? "text" : "password"}
                          fullWidth
                          value={cablePin}
                          onChange={(e) => setCablePin(e.target.value)}
                          sx={{ mb: 2 }}
                          inputProps={{ maxLength: 6 }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => setShowCablePin(!showCablePin)}
                                  edge="end"
                                >
                                  {showCablePin ? (
                                    <VisibilityOffIcon />
                                  ) : (
                                    <VisibilityIcon />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {cableError && (
                          <Typography color="error" sx={{ mb: 1 }}>
                            {cableError}
                          </Typography>
                        )}
                      </>
                    )}
                  </DialogContent>
                  {cableVerified && <DialogActions>
                    <Button
                      onClick={() => setCableDialogOpen(false)}
                      disabled={!subscribeCableTVMutation.isPending}
                    >
                      Cancel
                    </Button>

                    <CustomButton
                      onPress={handleCableSubscribe}
                      isLoading={subscribeCableTVMutation.isPending}
                      isEnabled={cablePlan && cablePhone && cablePin && cableVerified}
                      fullWidth={false}
                      label={"Subscribe"} />
                  </DialogActions>}
                </Dialog>
                <Snackbar
                  open={cableSnackbarOpen}
                  autoHideDuration={3000}
                  onClose={() => setCableSnackbarOpen(false)}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert
                    onClose={() => setCableSnackbarOpen(false)}
                    severity="success"
                    sx={{ width: "100%" }}
                    elevation={6}
                    variant="filled"
                  >
                    {cableSuccess}
                  </Alert>
                </Snackbar>
              </div>
            )}

            {!customized_app_displayable_menu_items["display-airtime-menu"] &&
              !customized_app_displayable_menu_items["display-cable-tv-menu"] &&
              !customized_app_displayable_menu_items[
              "display-electricity-menu"
              ] &&
              !customized_app_displayable_menu_items["display-data-menu"] && (
                <div>
                  <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 flex flex-col items-center min-h-[200px]">
                    <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-full flex items-center justify-center text-2xl mb-4">
                      📱
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Service Not Available
                    </h3>
                    <p className="text-gray-600 text-center mb-6">
                      The Bill Payment services are currently not available at
                      the moment. Please try again later.
                    </p>
                  </div>
                </div>
              )}
          </div>
        )}
      </main>
    </div>
  );
}
